// extracted by mini-css-extract-plugin
export default {"boxLoad":"Loading_boxLoad__lDofj"};